// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  width: 100vw;
  height: 5rem;
  display: grid;
  place-items: center;
  background: var(--color-primary);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  box-shadow: 0 1rem 1.5rem hsla(var(--primary-hue), 68%, 42%, 20%);
  transition: var(--transition);
}

.nav__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav__logo {
  width: 3rem;
  border-radius: 50%;
}

.nav__menu {
  display: flex;
  gap: 3.5rem;
}

.nav__menu a {
  color: white;
}

#theme__icon {
  background: transparent;
  color: white;
  font-size: 2rem;
  cursor: pointer;
}

/* Nav menu for tablets and phones */

@media screen and (max-width: 1024px) {
  .nav__menu {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,iEAAiE;EACjE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["nav {\n  width: 100vw;\n  height: 5rem;\n  display: grid;\n  place-items: center;\n  background: var(--color-primary);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  box-shadow: 0 1rem 1.5rem hsla(var(--primary-hue), 68%, 42%, 20%);\n  transition: var(--transition);\n}\n\n.nav__container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.nav__logo {\n  width: 3rem;\n  border-radius: 50%;\n}\n\n.nav__menu {\n  display: flex;\n  gap: 3.5rem;\n}\n\n.nav__menu a {\n  color: white;\n}\n\n#theme__icon {\n  background: transparent;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n}\n\n/* Nav menu for tablets and phones */\n\n@media screen and (max-width: 1024px) {\n  .nav__menu {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
